export default __webpack_public_path__ + "static/media/capsule-ready-small.0e74e216.png";